import { useState } from "react";
import { Box, Rating, Stack, Typography } from "@mui/material";
import "./TestimonialCard.scss";
import AvatarGenerator from "../../profilePic/GenerateAvatar";
import TestimonialModal from "../../../components/card/Testimonial/TestimonialModal";
import ImageView from "../../ImageView/ImageView";

export default function TestimonialCard({ reviewData, pujaDetails, selectedTempleDetails }: any) {
  const [reviewModalOpen, setReviewModalOpen] = useState<boolean>(false);
  const userName = reviewData?.userName?.split(" ");


  return (
    <>
      <Box className="testiCard" onClick={() => setReviewModalOpen(true)}>
        <Box className="cardTop">
          <Stack
            direction="row"
            alignItems="flex-start"
            justifyContent="flex-start"
            spacing={2}
          >
            <Box className="imageSec">
              {reviewData?.userImage ? (
                <ImageView src={reviewData?.userImage} alt="Devotee" />
              ) : (
                <AvatarGenerator
                  firstName={userName[0]}
                  lastName={userName[userName.length - 1]}
                />
              )}
            </Box>
            <Box className="nameSec">
              <Typography className="boldText lineClimp1">
                {reviewData?.userName ?? ""}
              </Typography>
              <Typography className="profText lineClimp1">
                {reviewData?.userProfession ?? ""}
              </Typography>
              <Typography className="placeText lineClimp1">{reviewData?.userPlace ?? ""}</Typography>
              <Rating
                name="simple-controlled"
                readOnly
                value={reviewData?.rating ?? 3}
                className="ratingStar"
              />
            </Box>
          </Stack>
        </Box>

        <Box className="cardBottom">
          <Box
            className="feedbackWrapper"
          >
            <Typography
              className="feedbackText"
            >
              {reviewData?.feedBack}
            </Typography>
          </Box>
        </Box>
      </Box>

      <TestimonialModal
        open={reviewModalOpen}
        onClose={() => setReviewModalOpen(false)}
        reviewData={reviewData}
        pujaDetails={pujaDetails}
        selectedTempleDetails={selectedTempleDetails}
      />
    </>
  );
}